import { CurrencyCell } from "@/components/shared/cells/currency";

import type { InvoiceData } from "@/apis/gql/types";
import { InvoiceStatus } from "@/lib/constants/invoiceStatus";

type Props = {
  invoice: Pick<
    InvoiceData,
    "totalAmount" | "currency" | "totalAmountConfidence" | "status"
  >;
  showConfidence?: boolean;
};

export const TotalAmountCell = ({ invoice, showConfidence = false }: Props) => {
  if (invoice.status === InvoiceStatus.NEW) return null;

  const confidence = invoice.currency ? invoice.totalAmountConfidence : 0;

  return (
    <CurrencyCell
      value={invoice.totalAmount}
      currency={invoice.currency}
      confidence={showConfidence ? confidence : undefined}
    />
  );
};
